<template>
  <div>
    <div id="wrapper" class="page">
      <div id="content-wrapper">
        <div class="container-fluid">
          <b-row>
            <b-col cols="12">
              <div class="form-inline">
                <b-form-select
                  v-model="year_selected"
                  class="mb-2 mr-2"
                  style="width: 7%"
                  :options="optionsYear"
                  value-field="value"
                  text-field="text"
                  @change="queryItem"
                >
                  <template #first>
                    <b-form-select-option value="-1">Year</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-select
                  v-model="month_selected"
                  class="mb-2 mr-2"
                  style="width: 7%"
                  :options="optionsMonth"
                  value-field="value"
                  text-field="text"
                  @change="queryItem"
                >
                  <template #first>
                    <b-form-select-option value="-1"
                      >Month</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <b-form-input
                  class="mb-2"
                  style="flex-grow: 1"
                  v-model="query"
                  placeholder="Find Job"
                  @keydown.enter.prevent="queryItem"
                  autocomplete="off"
                />
                <button class="btn" @click.prevent="queryItem">
                  <i class="fas fa-search"></i>
                </button>
                <button class="btn" id="popover-target-1">
                  <i class="fas fa-filter"></i>
                </button>
              </div>
            </b-col>
          </b-row>

          <b-popover target="popover-target-1" triggers="click blur">
            <template v-slot:title>Filters</template>
            <b-form-select
              v-model="status_selected"
              :options="optionsStatus"
              text-field="text"
              value-field="value"
              @change="queryItem"
            >
              <template v-slot:first>
                <b-form-select-option value="0">All</b-form-select-option>
              </template>
            </b-form-select>
          </b-popover>

          <b-table
            bordered
            head-variant="dark"
            hover
            responsive
            striped
            small
            table-variant="light"
            :fields="qtake_project_fields"
            :items="qtake_project_items"
          >
            <template v-slot:cell(rev_total)="data">
              {{ data.item.rev_total | numeral("0,0") }} USD
            </template>
            <template v-slot:cell(fee_total)="data">
              <div v-if="data.item.lockstatus == 0" style="color:green;">
                <b>{{ data.item.fee_total }} USD</b>
              </div>
              <div v-else>{{ data.item.fee_total }} USD</div>
            </template>
            <template v-slot:cell(profit)="data">
              {{ data.item.profit | numeral("0,0") }} USD
            </template>
            <template v-slot:cell(requirement)="data">
              {{ find_type(data.item.requirement, requirements) }}
            </template>
            <template v-slot:cell(shooting_date)="data">
              {{ data.item.shooting_date | moment("DD/MM/YYYY") }}
            </template>
            <template v-slot:cell(status)="data">
              <b-form-checkbox
                v-model="data.item.status"
                value="2"
                unchecked-value="1"
                @change="updatePaymentStatus(data)"
                :disabled="data.item.status == 0"
              />
            </template>
            <template v-slot:cell(project_status)="data">
              <b-badge variant="secondary" v-if="data.item.status == 0"
                >Not confirm</b-badge
              >
              <b-badge
                variant="danger"
                v-else-if="
                  data.item.status == 1 && is_shooting_date_smaller_than_today
                "
                >In Progress</b-badge
              >
              <b-badge
                variant="warning"
                v-else-if="
                  data.item.status == 1 && !is_shooting_date_smaller_than_today
                "
                >Payment</b-badge
              >
              <b-badge
                variant="success"
                v-else-if="
                  data.item.status == 2 && !is_shooting_date_smaller_than_today
                "
                >Complete</b-badge
              >
            </template>
            <template slot="bottom-row">
              <td style="text-align:center" colspan="4"><b>TOTAL</b></td>
              <td style="text-align:right">
                <b>{{ sum_revenue | numeral("0,0") }} USD</b>
              </td>
              <td style="text-align:right">
                <b>{{ sum_bonus | numeral("0,0") }} USD</b>
              </td>
              <td style="text-align:right">
                <b>{{ sum_profit | numeral("0,0") }} USD</b>
              </td>
              <td />
              <td />
              <td />
            </template>
            <template v-slot:cell(action)="data">
              <b-link
                class="text-info mr-2"
                href="#"
                @click.prevent="openRevenueModal(data)"
              >
                <i class="fas fa-calculator"></i>
              </b-link>
              <b-link
                class="text-warning mr-2"
                href="#"
                @click.prevent="openCostModal(data)"
              >
                <i class="fas fa-calculator"></i>
              </b-link>
              <b-link
                :id="data.item.id.toString()"
                class="text-success mr-2"
                href="#"
              >
                <i class="fas fa-download"></i>
                <b-popover
                  :target="data.item.id.toString()"
                  triggers="click blur"
                  placement="bottomleft"
                >
                  <b-form-select
                    v-model="download_type"
                    :options="optionsDownload"
                    text-field="text"
                    value-field="value"
                    placeholder="Chose a file type"
                    @change="downloadFile(data)"
                  >
                    <template #first>
                      <b-form-select-option :value="null" disabled
                        >-- Choose a file type --</b-form-select-option
                      >
                    </template>
                  </b-form-select>
                </b-popover>
              </b-link>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <!-- REVENUE MODAL -->
    <b-modal
      v-model="revenueModalShow"
      size="xl"
      @hidden="closeRevenueModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      header-bg-variant="info"
      header-text-variant="light"
      hide-footer
    >
      <template v-slot:modal-title>
        REVENUE
      </template>
      <b-table
        bordered
        head-variant="dark"
        hover
        responsive
        striped
        small
        table-variant="light"
        :fields="revenue_fields"
        :items="revenue_items"
      >
        <template v-slot:cell(unit)="data">
          <div v-if="data.item.description == ''">
            <b>{{ data.item.unit }}</b>
          </div>
          <div v-else>{{ data.item.unit | numeral("0,0") }}</div>
        </template>
        <template v-slot:cell(total)="data">
          <div v-if="data.item.unit == 'DISCOUNT:' && revenue_edit_status < 2">
            <my-currency-input v-model="edit_discount" />
          </div>
          <div v-else>{{ data.item.total | numeral("0,0") }}</div>
        </template>
      </b-table>
      <button
        v-if="revenue_edit_status < 2"
        class="btn btn-info"
        style="float:right;"
        @click.prevent="updateRevenue"
      >
        <i class="fas fa-save mr-2"></i> Save
      </button>
    </b-modal>
    <!-- END OF REVENUE MODAL -->

    <!-- COST MODAL -->
    <b-modal
      v-model="costModalShow"
      @hidden="closeCostModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      header-bg-variant="info"
      header-text-variant="light"
      hide-footer
    >
      <template v-slot:modal-title>
        BONUS
      </template>
      <b-form autocomplete="off">
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Qtake's Manager rate:
                <b
                  >({{ cost.fee_management }} *
                  {{ cost.rev_total | numeral("0,0") }} =
                  {{ (cost.fee_management * cost.rev_total) | numeral("0,0") }}
                  USD)</b
                >
              </template>
              <b-form-input
                type="number"
                step="0.01"
                v-model="cost.fee_management"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Qtake's Coordinator bonus:
                <b>({{ findEmployee(cost.coordinatorid) }})</b>
              </template>
              <my-currency-input
                v-model="cost.fee_coordinator"
                :locked="true"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Qtake's Operator bonus:
                <b>({{ findEmployee(cost.operatorid) }})</b>
              </template>
              <my-currency-input v-model="cost.fee_operator" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Qtake's Assistant bonus:
                <b>({{ findEmployee(cost.assistantid) }})</b>
              </template>
              <my-currency-input v-model="cost.fee_assistant" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Others fee:
              </template>
              <my-currency-input v-model="cost.fee_others" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Tỷ giá:
              </template>
              <my-currency-input v-model="cost.quydoiusd" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-checkbox
              v-model="cost.lockstatus"
              unchecked-value="0"
              value="1"
              >Paid bonus</b-form-checkbox
            >
          </b-col>
          <b-col cols="6">
            <button
              class="btn btn-info"
              style="float:right;"
              @click.prevent="updateCost"
            >
              <i class="fas fa-save mr-2"></i> Save
            </button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <!-- END OF COST MODAL -->
  </div>
</template>

<script>
import axios from "axios";
import MyCurrencyInput from "../components/App/MyCurrencyInput";

export default {
  name: "QtakeProject",
  components: {
    MyCurrencyInput,
  },
  data() {
    return {
      month_selected: -1,
      year_selected: -1,
      query: null,
      optionsMonth: [
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 11, text: "November" },
        { value: 12, text: "December" },
        { value: 13, text: "Quarter I" },
        { value: 14, text: "Quarter II" },
        { value: 15, text: "Quarter III" },
        { value: 16, text: "Quarter IV" },
      ],
      optionsStatus: [
        { value: 1, text: "Unpaid" },
        { value: 2, text: "Paid" },
      ],
      qtake_project_fields: [
        {
          key: "project",
          label: "Job",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "production",
          label: "Company",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "shooting_date",
          label: "Shooting date",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "requirement",
          label: "Requirement",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "rev_total",
          label: "Revenue",
          tdClass: "text-right",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "fee_total",
          label: "Bonus",
          tdClass: "text-right",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "profit",
          label: "Profit",
          tdClass: "text-right",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "project_status",
          label: "Status",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "status",
          label: "Payment",
          sortable: true,
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "action",
          label: "",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { width: "100px !important", textAlign: "center" },
        },
      ],
      revenue_fields: [
        {
          key: "description",
          label: "DESCRIPTION",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "quantity",
          label: "QTY",
          tdClass: "text-center",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "unit",
          label: "UNIT USD",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "total",
          label: "TOTAL USD",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
      ],
      cost: {
        id: 0,
        fee_management: 0,
        fee_coordinator: 0,
        fee_operator: 0,
        fee_assistant: 0,
        fee_others: 0,
        rev_total: 0,
        lockstatus: 0,
        coordinatorid: 0,
        operatorid: 0,
        assistantid: 0,
        quydoiusd: 0,
      },
      requirements: [
        // { id: null, type: "Please choose requirement..." },
        // { id: 0, type: "Playback" },
        // { id: 1, type: "Playback & Live streaming" },
      ],
      optionsDownload: [
        { value: 0, text: "Excel" },
        { value: 1, text: "PDF" },
      ],
      download_type: null,
      qtake_project_items: [],
      revenue_items: [],
      qtake_departments: [],
      revenueModalShow: false,
      costModalShow: false,
      edit_discount: 0,
      edit_qtake_id: 0,
      edit_index: -1,
      edit_status: -1,
      revenue_edit_status: 0,
      cost_edit_status: 0,
      status_selected: 0,
      employees: [],
    };
  },
  computed: {
    optionsYear() {
      var result = [];
      var this_year = new Date().getFullYear();
      for (var i = this_year; i >= 2020; i--) {
        result.push({ value: i, text: i });
      }
      return result;
    },
    is_shooting_date_smaller_than_today(date) {
      let today = new Date();
      let shooting_date = new Date(date);

      return today < shooting_date;
    },
    sum_revenue() {
      let sum = 0;
      for (let item of this.qtake_project_items) {
        sum += item.rev_total;
      }
      return sum;
    },
    sum_bonus() {
      let sum = 0;
      for (let item of this.qtake_project_items) {
        sum += item.fee_total;
      }
      return sum;
    },
    sum_profit() {
      let sum = 0;
      for (let item of this.qtake_project_items) {
        sum += item.profit;
      }
      return sum;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get(`/api/qtakeproject`, { params: to.query }),
        axios.get("/api/qtakedepartment/use"),
        axios.get("/api/employee/getall"),
        axios.get("/api/picklist?q=qtake_Requirement"),
      ])
      .then(
        axios.spread((qtake_project, qtake_department, employee, picklist) => {
          next((vm) =>
            vm.initData(
              qtake_project.data,
              qtake_department.data,
              employee.data,
              picklist.data
            )
          );
        })
      );
  },
  beforeRouteUpdate(to, from, next) {
    axios
      .get(`/api/qtakeproject`, { params: to.query })
      .then((res) => {
        this.qtake_project_items = res.data;
        // next();
      })
      .catch((err) => {
        next();
      });
  },
  methods: {
    initData(qtake_projects, qtake_departments, employees, picklists) {
      this.qtake_project_items = qtake_projects;
      this.qtake_departments = qtake_departments;
      this.employees = employees;
      this.requirements = picklists.filter(
        (plt) => plt.pickListType == "qtake_Requirement"
      );
      this.requirements.unshift({
        id: null,
        pickListType: "qtake_Requirement",
        pickListValue: "Please choose a requirement...",
      });
      this.year_selected = new Date().getFullYear();
    },
    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      query.year = this.year_selected;
      query.month = this.month_selected;
      query.status = this.status_selected;
      this.$router.push({ query: query });
    },
    find_type(id, list) {
      return list.find((x) => x.id == id).pickListValue;
    },
    openRevenueModal(data) {
      let description = "Qtake remote playback";
      let price = data.item.price_playback;
      let quantity = data.item.songay;

      if (data.item.requirement == data.item.playbacklivestreamid) {
        description = "Qtake live streaming & remote playback";
        price = data.item.price_playback_livestream;
      }

      this.revenue_items.push({
        description: description,
        quantity: quantity,
        unit: price,
        total: price * quantity,
      });

      let subtotal = 0;
      for (let item of this.revenue_items) {
        subtotal += item.total;
      }

      this.edit_qtake_id = data.item.id;
      this.edit_discount = data.item.rev_discount;
      this.edit_index = data.index;
      this.revenue_edit_status = data.item.status;

      this.revenue_items.push({
        description: "",
        quantity: "",
        unit: "SUBTOTAL:",
        total: subtotal,
      });
      this.revenue_items.push({
        description: "",
        quantity: "",
        unit: "DISCOUNT:",
        total: data.item.rev_discount,
      });
      this.revenue_items.push({
        description: "",
        quantity: "",
        unit: "TOTAL:",
        total: subtotal - data.item.rev_discount,
      });

      this.revenueModalShow = true;
    },
    closeRevenueModal() {
      this.revenue_items = []; // Remember to flush the array ofcourse
      this.edit_qtake_id = 0;
      this.edit_discount = 0;
      this.edit_index = -1;
      this.revenue_edit_status = 0;
      this.revenueModalShow = false;
    },
    updateRevenue() {
      let qtake = { id: this.edit_qtake_id, rev_discount: this.edit_discount };
      axios
        .put("/api/qtakeproject/discount", qtake)
        .then((res) => {
          this.qtake_project_items = this.$insert_array_parse_json(
            res.data,
            this.qtake_project_items
          );
          this.$toast.success("Successfully update Revenue!", "Success", {
            timeout: 2000,
          });
          this.closeRevenueModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 2000 });
        });
    },
    openCostModal(data) {
      this.cost = JSON.parse(JSON.stringify(data.item));
      this.cost_edit_status = data.item.lockstatus;
      this.costModalShow = true;
    },
    closeCostModal() {
      this.cost_edit_status = 0;
      this.costModalShow = false;
    },
    updateCost() {
      this.cost.lockstatus = parseInt(this.cost.lockstatus);
      this.cost.status = 0; // @???: Because I hate JS
      axios
        .put("/api/qtakeproject/cost", this.cost)
        .then((res) => {
          this.qtake_project_items = this.$insert_array_parse_json(
            res.data,
            this.qtake_project_items
          );
          this.$toast.success("Successfully update Cost!", "Success", {
            timeout: 2000,
          });
          this.closeCostModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 2000 });
        });
    },
    updatePaymentStatus(data) {
      let status = data.item.status == 1 ? 2 : 1;
      let changed_status = { id: data.item.id, status: status };
      axios
        .put("/api/qtakeproject/status", changed_status)
        .then((res) => {
          this.$toast.success("Successfully update status!", "Success", {
            timeout: 2000,
          });
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 2000 });
        });
    },
    downloadFile(data) {
      // let so_bao_gia = this.year_selected + this.month_selected + (data.index + 1); User ko filter
      var d = new Date(data.item.shooting_date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      let so_bao_gia = [year, month, day].join("_");
      let ten_cong_ty = data.item.production;
      let ten_job = data.item.project;
      let filename = "QTAKE_" + so_bao_gia + "_" + ten_cong_ty + "_" + ten_job;
      let query = Object.assign({}, this.$route.query);
      query.qtake_id = data.item.id;
      query.filename = filename;
      query.type = this.download_type;
      axios({
        method: "get",
        url: `/api/qtakereport/project`,
        params: query,
        responseType: "blob", // important
      })
        .then((res) => {
          if (this.download_type == 0) this.$download_excel_file(res);
          if (this.download_type == 1) this.$download_pdf_file(res);
          this.download_type = null; //Tra ve null khi download xong
          this.closeReportModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 2000 });
        });
    },
    findEmployee(employee_id) {
      let employee = this.employees.find((x) => x.id == employee_id);

      if (typeof employee == "undefined") return "";

      return employee.mahovaten;
    },
  },
};
</script>
